export const SCOPE_RESOURCE_TO_CATEGORY: Record<string, string> = {
  ext_user: 'Contacts',
  room_session: 'Meetings',
  room: 'Meetings',
  room_event: 'Meetings',
  room_record: 'Meetings',
  airesult: 'Results',
  aifeature: 'Results',
  ai_agent: 'Results',
  ai_agent_result: 'Results',
  integration: 'Integrations',
  task: 'Tasks',
  meeting_template: 'Meeting Templates',
  meeting_note: 'Meeting Notes',
  scorecard: 'Scorecards',
  scorecardresult: 'Scorecards',
  webhook: 'Webhooks',
  user: 'Users',
  insights: 'Analytics',
  file: 'Transcripts',
}

// Curated display order for scope categories. Categories not listed here are
// appended after these (in encounter order), with 'Other' always kept last.
export const SCOPE_CATEGORY_ORDER: string[] = ['Users', 'Contacts', 'Meetings', 'Meeting Templates', 'Results', 'Tasks', 'Transcripts', 'Integrations']

export type ScopeAccessType = 'read' | 'write' | 'admin'

const READ_ACTIONS = new Set(['read', 'list', 'get', 'download', 'download_attachment', 'sample'])

export const getScopeAccessType = (scopeId: string): ScopeAccessType => {
  const action = scopeId.split(':')[1] ?? ''
  if (action === 'admin' || action.startsWith('admin_')) {
    return 'admin'
  }
  if (READ_ACTIONS.has(action)) {
    return 'read'
  }
  return 'write'
}

export const getScopeCategory = (scopeId: string): string => {
  const resource = scopeId.split(':')[0]
  return SCOPE_RESOURCE_TO_CATEGORY[resource] ?? 'Other'
}

export const groupByScopeCategory = <T>(items: T[], getItemCategory: (item: T) => string): Map<string, T[]> => {
  const grouped = items.reduce((acc, item) => {
    const category = getItemCategory(item)
    const list = acc.get(category) ?? []
    acc.set(category, [...list, item])
    return acc
  }, new Map<string, T[]>())

  const rank = (category: string) => {
    const index = SCOPE_CATEGORY_ORDER.indexOf(category)
    if (index !== -1) {
      return index
    }
    // Unlisted categories sort after the curated ones, but 'Other' always last.
    return category === 'Other' ? Number.MAX_SAFE_INTEGER : SCOPE_CATEGORY_ORDER.length
  }

  return new Map([...grouped.entries()].sort(([a], [b]) => rank(a) - rank(b)))
}

export const groupPermissionsByScopeCategory = (permissions: { id: string; description: string }[]): Map<string, { id: string; description: string }[]> =>
  groupByScopeCategory(permissions, (p) => getScopeCategory(p.id))
